import { createApp } from 'vue'
import App from './App.vue'
import router, { setupRouter } from './router' // 路由

import '@/assets/styles/index.scss'
import '@/assets/styles/tailwind.css'

import ElementPlus from 'element-plus'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import { setupStore } from './store'

// createApp(App).mount('#app')
const app = createApp(App)
app.use(ElementPlus, {
  locale: zhCn
})
setupStore(app)
setupRouter(app)
router.isReady().then(() => {
  app.mount('#app')
})
